module.exports = __webpack_public_path__ + "img/t3-black.cdc46865.png";